<div id="dropzone"
    [ngClass]="['dot', this.wrapperClass ]"
    (drop)="fileDropListener($event)"
    ngFileDrop [options]="options"
    (uploadOutput)="onUploadOutput($event)"
    [uploadInput]="uploadInput"
    (click)="ctlFileID.click();" style="align-items: middle;">

    <img [ngClass]="fixLogoUrl(this.myForm.get('logo').value?.url)?'img-pos1':'img-pos'"  id="ctlFile" alt="" 
    [src]="fixLogoUrl(this.myForm.get('logo').value?.url)">
    <!--<img style="float: left;" [ngClass]="this.imgClass"  id="ctlFile" alt="" [src]="this.myForm.get('logo').value?.url?.replace('<FILEBASEURL>', environment.msdpAPIBaseURL)">-->
    <!-- earlier btn class was written in span like this:- <span class=" btn btn-link centered" style="padding:0;"> -->
      <span class="btn-link centered" style="padding:0;">
      <input id="ctlFileID" #ctlFileID style="font-size: 0;" type="file" accept="image/png, image/jpeg, image/gif" name="file-upload" (change)="fileChangeListener($event)" ngFileSelect [options]="options " (uploadOutput)="onUploadOutput($event) " [uploadInput]="uploadInput">
      <!-- <span id=uploadicon 
      class="glyphicon glyphicon-open icon-upload" *ngIf="!this.myForm.get('logo').value?.url"></span> -->
      <br/>
      <!-- earlier btn class was written in span like this:- <span class=" btn btn-link opac-6"-->
      <span class="btn-link opac-6" style="padding:0;font-size: 10px; margin-left: 1px;" *ngIf="!this.myForm.get('logo').value?.url">
        <i class="icon icon-upload opac-6 upl"></i>
        {{'Upload image' | translate}}</span>
    </span>
</div>
<div class="upload-items" *ngIf="this.files && this.files.length;" style="position: absolute;z-index: 100;">
    <div class="upload-item" *ngFor="let f of files; let i = index;">
        <span class="filename">
        <span>{{ f.name | truncate:10 }} ({{ f.id }}) - {{ f.progress?.data?.percentage }}%</span>
        <span>uploading with {{ f.progress?.data?.speedHuman }}</span>
        <span>ETA {{ f.progress?.data?.etaHuman }}</span>
        </span>
        <div class="progress">
            <span class="bar" [style.width]="f?.progress?.data?.percentage + '%'"></span>
        </div>
    </div>
</div>
<!--
<div style="col-sm-7" *ngIf="(this.files && this.files.length) || (this.myForm.controls.logo?.value)">
  <a (click)="removePhoto()">
    Remove Photo
  </a>
</div>
-->
